import React from 'react';
import cmsUtils from '../cmsUtils';
import { InstagramFeed } from 'components';
import { isOffline } from '@site/_offline';

export const renderRule = {
  match: (item, cmsOption) => (cmsUtils.getCodeJson(item) || {})['control'] === 'instagram', 
  itemElt: (item, cmsOption) => (!isOffline() && <InstagramFeed />)
}